import styles from './AuditedFinancials.module.scss';
import DownloadPurple from '../../../../assets/download-purple.svg';
import { useAuditedReportDownload } from './useAuditedReportDownload';
import LoadingSpinner from '../../../../common/_custom/LoadingSpinner/LoadingSpinner';

interface AuditedFinancialsProps {
    assesseeOrgId: string;
    companyName?: string;
}

function AuditedFinancials({ assesseeOrgId, companyName = '' }: AuditedFinancialsProps) {
    const { downloading, onDownloadClick } = useAuditedReportDownload({ assesseeOrgId, orgName: companyName });

    return (
        <button
            type="button"
            className={styles.DownloadControl}
            onClick={onDownloadClick}
            disabled={downloading}
            aria-label="Download"
        >
            {downloading ? (
                <LoadingSpinner height="16px" color="#6021b3" style={{ margin: 0 }} />
            ) : (
                <img src={DownloadPurple} alt="" width={16} height={16} />
            )}
            <span>Download</span>
        </button>
    );
}

export default AuditedFinancials;
